// Officer dashboard
import React from 'react';
import View from 'src/pages/coming-soon';

const Page = () => {
  return <View />;
};

export default Page;
